<template>
    <div class="load-structures-results">
        <div class="row">
            <div class="col-12 col-sm">
                <span class="result-section">{{ structures.length }} Estructuras Cargadas</span>
            </div>
            <div class="col-12 col-sm">
                <span class="result-section">{{ people.length }} Personas Cargadas</span>
            </div>
            <div class="col-12 col-sm">
                <span class="result-section">{{ vehicles.length }} Vehiculos Cargados</span>
            </div>
        </div>
        <div class="row alert alert-danger errors-section" v-if="errors.length > 0">
            <div class="col">
                <h4>Errores ({{ errors.length }})</h4>
                <ol>
                    <li v-for="error in errors">
                        {{ error }}
                    </li>
                </ol>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            structures: {
                type: Array
            },
            people: {
                type: Array
            },
            vehicles: {
                type: Array
            },
            errors: {
                type: Array
            }
        }
    }
</script>
<style scoped>
    .load-structures-results {
        margin-top: 15px;
        padding: 15px;
    }
    .result-section {
        font-weight: 900;
        text-align: center;
    }
    .errors-section {
        height: 200px;
        overflow: auto;
    }
</style>